// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"reg-item-image__wrapper__1mwud","bannerWrapper":"reg-item-image__bannerWrapper__2--CL"};